export const ICoordinatorServiceType = Symbol('ICoreCoordinatorService');
